import './CometProgressDialog.scss';
import { Modal } from 'react-bootstrap';
import { Spinner } from '@Components/Spinner';
import { CometProgress } from '../../utils/fetch-utils';

interface CometProgressDialogProps {
  show: boolean;
  title?: string;
  progress?: CometProgress;
}

export const CometProgressDialog = ({
  show,
  title = 'Working…',
  progress
}: CometProgressDialogProps) => {
  const percent = progress?.percent ?? 0;
  return (
    <Modal
      show={show}
      onHide={() => {}}
      centered
      backdrop='static'
      keyboard={false}
      contentClassName='comet-progress-dialog'
    >
      <Modal.Body>
        <h4 className='dialog-title'>{title}</h4>
        <div className='progress-track'>
          <div className='progress-fill' style={{ width: `${percent}%` }} />
        </div>
        <div className='progress-status'>
          <Spinner size={20} />
          <span>{progress?.message ?? `${percent}% complete`}</span>
        </div>
      </Modal.Body>
    </Modal>
  );
};
